import { cardRef, defineGameCard, onResolve } from '../authoring/index.js';
import { plannedCell, tableOf } from './helpers.js';
import { ScrapCard } from './tokens.js';
export const JunkBarricadeCard = defineGameCard({
    id: 'junk_barricade',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: {
            target: 'cell',
            validatePlan(state, playerId, plan) {
                const cell = plan.targetCellId === undefined ? undefined : state.board.cells[plan.targetCellId];
                return cell !== undefined && cell.side === state.players[playerId]?.side;
            },
        },
    },
    presentation: {
        name: 'Мусорный заслон',
        description: 'Создайте до 2 единиц Хлама в выбранной локации.',
        glyph: {
            colors: ['#10213A', '#9C6D3A', '#795C3B', '#523F29', '#302421'],
            rows: [
                '....................',
                '....................',
                '.......111..........',
                '.......222111.......',
                '......13422221......',
                '.....4333324441.....',
                '....11133344441.....',
                '..1344413241511.1...',
                '..11433121331221.1..',
                '...133311133322111..',
                '..11355143444124441.',
                '.134351324443341541.',
                '.144113311444341441.',
                '..15333231133455141.',
                '.111335221143454541.',
                '5555433453444444551.',
                '.55111111115555551..',
                '...111411111111111..',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('scrap')],
    abilities: [
        onResolve((ctx) => {
            const targetCellId = plannedCell(ctx);
            if (targetCellId === undefined)
                return;
            const ownerId = ctx.self.controllerId;
            for (let index = 0; index < 2; index += 1) {
                ctx.ops.createTokenInLocation(ScrapCard.id, ownerId, tableOf(targetCellId));
            }
        }),
    ],
    ui: { mechanics: ['scrap'] },
});
//# sourceMappingURL=junk-barricade.js.map